import { BaseTag }   from "mixs/base/base_mixin";
import watch from "redux-watch";
import isEqual from 'is-equal';
import flatpickr from 'flatpickr';
import moment from 'moment';
const Japanese = require("flatpickr/dist/l10n/ja.js").Japanese;
import {
  DELIVERY_SELECT_START_DATE
} from 'apps/events';

class DateUI extends BaseTag {
  start: string;
  datePicker:      any; // FlatpickrInstance
  init(){
    super.init();
    this.start = this.opts.start;
    this.listenMount([this.onMountDateUI])
  }
  onMountDateUI(){
    this.setDatePicker();
  }
  setDatePicker(){
    let options:Partial<any>          = this.datePickerOptions();
    this.datePicker      = flatpickr(this.dateInput(), options);
  }
  onChange(){
    let value = this.dateInput().value;
    let newDate = moment(value);
    this.dispatchNewDate(newDate);
  }
  datePickerOptions(){
    return {
      mode:   "single",
      wrap: false,
      locale: Japanese
    };
  }
  dateInput(): HTMLInputElement {
    return <HTMLInputElement>this.querySelector('input[data-type="date"]');
  }
  onClickPrevWeek(){
    let newDate = this.getNewDateFrom(-1, 'week');
    this.dispatchNewDate(newDate);
  }
  onClickPrev2Weeks(){
    let newDate = this.getNewDateFrom(-2, 'week');
    this.dispatchNewDate(newDate);
  }
  onClickNextWeek(){
    let newDate = this.getNewDateFrom(1, 'week');
    this.dispatchNewDate(newDate);
  }
  onClickNext2Weeks(){
    let newDate = this.getNewDateFrom(2, 'week');
    this.dispatchNewDate(newDate);
  }
  dispatchNewDate(to){
    let params = { d: to.format('YYYY-MM-DD') };
    App.location.visit({ search: params });
  }
  private getNewDateFrom(num: any, unit: string): any{
    let currentStartDate = this.opts.start;
    let date = moment(currentStartDate);
    return date.add(num, unit);
  }
}
riot.mixin('calendars.date-ui', DateUI as riot.TagMixin)
